import * as React from 'react'
import styled from 'styled-components'

import PrivacyModal from '../PrivacyPolicyModal2/PrivacyPolicyModal'

const StyledLink = styled.a`
  cursor: pointer;
`

function PrivacyModalLink({
  children,
  zIndex,
  tab,
  isAyalaPN,
  onClick,
  ...theProps
}) {
  const [isModalShown, setModalShown] = React.useState(false)

  return (
    <StyledLink
      zIndex={10021}
      {...theProps}
      onClick={e => {
        e.preventDefault()
        onClick && onClick(e)
        setModalShown(true)
      }}
    >
      {children || 'Privacy Policy'}
      <PrivacyModal
        isAyalaPN={isAyalaPN}
        zIndex={zIndex}
        show={isModalShown}
        onClose={() => {
          setModalShown(false)
        }}
      />
    </StyledLink>
  )
}

export default PrivacyModalLink
